import React,{ Component } from 'react';
import PropTypes from "prop-types"
import { withRouter, Link } from 'react-router-dom';
import {bindActionCreators} from "redux";
import Logo from '../../../images/logo.png';
import {RootActions} from "../../../shared/root-action";
import {connect} from "react-redux";
import AuthHelper from "../../../libraries/auth-helper";
import language from '../../../libraries/label-lang';
import Button from '@material-ui/core/Button';
import {history} from "../../../shared/configure-store";
import Api from "../../../libraries/api";
import NumberFormat from 'react-number-format';
import _ from 'lodash';
import {toast} from "react-toastify/index";


class Sidebar extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            menus: [],
            balance: '',
            credit: '',
            loadingFetch: false,
            count: 0,
        };
    }

    componentDidMount() {

        this.interval = setInterval(() => {
            let fetchPayment = this.__fetchPayment;
            let listPayment = AuthHelper.getPayment();
            let count = this.state.count;
            if(listPayment) {
                if(count < listPayment.length && listPayment.length > 0){
                    fetchPayment(listPayment[count]);
                }else{
                    clearInterval(this.interval);
                }
            }else {
                clearInterval(this.interval);
            }
        }, 5000);

        Api.get('/wallets/current').then(resp => {
            if (resp.data) {

                this.setState({
                    balance: resp.data ? parseFloat(resp.data.current_balance) : 0,
                    credit: resp.data ? parseFloat(resp.data.credit_limit) : 0,
                })

            }
        }).catch(err => {
            console.log(err);

            this.setState({
                    loading: true,
                }
            );

        });
    }

    __fetchPayment = (obj) => {

        this.setState({
            loadingFetch: true,
        });

        let params = {
            "status": "",
            "message": "",
            "data": {
                "request": {
                    "generatedUrl": obj.generatedUrl
                }
            }
        };

        Api.post('https://api-link.cashlez.com/validate_url', params, false).then(resp => {

            if (resp.data) {
                let response = resp.data.response;

                this.setState({
                        loadingFetch: false,
                        fetchStatus: response.status === 'INVALID',
                        count: this.state.count+1,
                    }
                );

                if(response.processStatus === 'APPROVED') {
                    this.__paymentSuccess(obj.referenceId);
                }

                if(response.processStatus === 'REJECTED') {
                    this.__paymentFailed(obj.referenceId);
                }
            }


        }).catch(err => {

            this.showMessage(false, 'CASHLEZ API Status: ERROR');
        });

    };

    __paymentFailed = (id) => {
        let params = {
            reference_id: id,
        };

        Api.put('/wallets/failed/top_up', params).then(resp => {

            this.__removeItem(id);

        }).catch(err => {

            this.showMessage(false, err.message);

        });

    };

    __paymentSuccess = (id) => {
        let params = {
            reference_id: id,
        };

        Api.put('/wallets/success/top_up', params).then(resp => {
            this.__removeItem(id);

        }).catch(err => {

            this.showMessage(false, err.message);
        });

    };

    __removeItem = (id) => {
        let payment = AuthHelper.getPayment();
        _.remove(payment, {
            referenceId: id
        });
        this.setState({
                count: 0,
            }
        );

        AuthHelper.setPayment(payment);
    };

    handleLogout = () => {

        AuthHelper.logOut();

    };

    handleGo  = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    render() {
        const { location } = this.props;
        let lang = {};
        let company_name ='';
        let contact_name = '';
        let profile = this.props.profile_state.tenantUser;

        if (profile) {
            company_name = profile.company_name;
            contact_name = profile.contact_name;
        }

        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return(

            <aside className={"side-nav " + (this.props.toggle_sidebar_state ? "show" : "")  } >
                <div className='header-logo'>
                    <img src={Logo} alt='logo' />
                </div>

                <ul className='nav flex-column'>
                    <div className='card-sidenav'>
                        <div className='card-header'>
                            <h4>{company_name}</h4>
                            <span>{contact_name}</span>
                        </div>
                    </div>
                    <div className='card-sidenav'>
                        <div className='card-header'>
                            <i className='fas fa-wallet'> </i>
                            <span>Dompet Anda</span>
                        </div>
                        <div className='card-body'>
                            <p className='mb-2'>Saldo Anda,</p>
                            <h4 className='number'>
                                Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} decimalScale={2}
                                                 value={this.state.balance} displayType={'text'} renderText={value => value} />
                            </h4>
                            <p className='mb-2'>Kredit Tersedia : <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false}
                                                                                decimalScale={0} value={this.state.credit} displayType={'text'} renderText={value => value}/></p>
                            <div className='row'>
                                <div className='col-6'>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={() => this.handleGo('/histories/topup')}
                                        fullWidth
                                    >
                                        Top Up
                                    </Button>
                                </div>
                                <div className='col-6'>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        onClick={() => this.handleGo('/histories')}
                                        fullWidth
                                    >
                                        Riwayat
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <li className={location.pathname === '/' ? 'nav-item active' : 'nav-item'}>
                        <Link to='/'><i className='fas fa-home'> </i> {text.label_dashboard}</Link>
                    </li>
                    <li className={location.pathname === '/products' ? 'nav-item active' : 'nav-item'}>
                        <Link to='/products'><i className='fas fa-user-tie'> </i> {text.label_products}</Link>
                    </li>
                    <li className={location.pathname === '/reservations' ? 'nav-item active' : 'nav-item'}>
                        <Link to='/reservations'><i className='fas fa-book-reader'> </i> {text.label_reservation}</Link>
                    </li>
                    <li className={location.pathname === '/inventories' ? 'nav-item active' : 'nav-item'}>
                        <Link to='/inventories'><i className='fas fa-book-reader'> </i> {text.label_assets}</Link>
                    </li>
                    <li className={location.pathname === '/orders' ? 'nav-item active' : 'nav-item'}>
                        <Link to='/orders'><i className='fas fa-shopping-cart'> </i> {text.label_orders}</Link>
                    </li>
                  {/*  <li className={location.pathname === '/assets' ? 'nav-item active' : 'nav-item'}>
                        <Link to='/assets'><i className='fas fa-home'> </i> {text.label_assets}</Link>
                    </li>*/}

                    <li className='nav-item'>
                        <button onClick={this.handleLogout}><i className='fas fa-sign-out-alt'> </i> {text.label_logout}</button>
                    </li>
                </ul>
            </aside>

        )

    }

}

const mapStateToProps = (state) => {

    return {

        toggle_sidebar_state: state.toggle_sidebar_state,

        toggle_set_lang: state.toggle_set_lang,

        profile_state: state.profile_state,

        permission_state: state.permission_state,


    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));